module.exports = __webpack_public_path__ + "img/Create Extra.dd8c59ca.png";